import React from 'react';
import { connect } from 'react-redux';
import { defineMessages, injectIntl } from 'react-intl';

const messages = defineMessages({
  AUDIO_STATUS_REQUESTED: { id: 'AudioRequestedState.AUDIO_STATUS_REQUESTED', defaultMessage: 'Warten bis der Kunde sein Mikrofon freischaltet.' },
  AUDIO_STATUS_ON: { id: 'AudioRequestedState.AUDIO_STATUS_ON', defaultMessage: 'Ton erfolgreich aktiviert.' },
  AUDIO_STATUS_OFF: { id: 'AudioRequestedState.AUDIO_STATUS_OFF', defaultMessage: 'Der Kunde hat den Vorgang abgebrochen.' },
});


class AudioRequestedState extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
    };
  }

  componentWillReceiveProps(nextProps) {
    const { formatMessage } = this.props.intl;
    if (!this.props.requested && nextProps.requested) {
      this.setState({ status: formatMessage(messages.AUDIO_STATUS_REQUESTED) });
    }
    if (this.props.requested && !nextProps.requested) {
      this.setState({ status: nextProps.active ? formatMessage(messages.AUDIO_STATUS_ON) : formatMessage(messages.AUDIO_STATUS_OFF) });
      setTimeout(() => this.setState({ status: null }), 2500);
    }
  }

  render() {
    const { status } = this.state;
    if (!status) {
      return <div />;
    }
    return (
      <div className="video-overlay">{status}</div>
    );
  }
}

export default connect(
  state => ({
    requested: state.audio.self.requested,
    active: state.audio.remote.active,
  })
)(injectIntl(AudioRequestedState));
